import React from 'react';
import styles from './no-product-found.scss';

const NoProductFound= (props) => {
    let imgSrc = props.imgSrc || 'https://image1.jdomni.in/jdomni_email/noProducts.svg';
    let noProductFoundLabel = props.label || 'No Products are Awaiting Deletion';
    return (
        <div className='no-product-found-div'>
            {
                props?.IconComp ? <props.IconComp /> : <img src={imgSrc} />
            }
            <div className='not-found-label'>
                {props?.twoLineText ? 
                    <>
                        <div>{props?.labelOne}</div>
                        <div>{props?.labelTwo}</div>
                    </>
                : noProductFoundLabel}
            </div>
            {
                props?.isBtn ? <button className="no-prod-btn" onClick={props?.btnClick}>{props?.btnTxt}</button> : null
            }
        </div>
    )
}

export default NoProductFound;